// src/utils/currency.ts
export const formatCurrency = (
  amount: number | string | undefined,
  currency: string = "USD"
): string => {
  if (amount === undefined || amount === null) return "$0.00";

  const numAmount = typeof amount === "string" ? parseFloat(amount) : amount;

  if (isNaN(numAmount)) return "$0.00";

  if (
    currency === "BTC" ||
    currency === "ETH" ||
    currency === "BNB" ||
    currency === "SOL"
  ) {
    return `${numAmount.toFixed(8)} ${currency}`;
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numAmount);
};

export const formatCrypto = (
  amount: number | string | undefined,
  symbol: string
): string => {
  if (amount === undefined || amount === null) return `0.00000000 ${symbol}`;

  const numAmount = typeof amount === "string" ? parseFloat(amount) : amount;

  if (isNaN(numAmount)) return `0.00000000 ${symbol}`;

  return `${numAmount.toFixed(8)} ${symbol}`;
};

export const formatFiat = (amount: number | string | undefined): string => {
  return formatCurrency(amount, "USD");
};

export const formatAbbreviatedCurrency = (amount: number): string => {
  if (amount >= 1000000000) {
    return `$${(amount / 1000000000).toFixed(1)}b`;
  } else if (amount >= 1000000) {
    return `$${(amount / 1000000).toFixed(1)}m`;
  } else if (amount >= 1000) {
    return `$${(amount / 1000).toFixed(1)}k`;
  } else {
    return `$${amount.toFixed(2)}`;
  }
};
